import { render } from "./OrderDetailsComponent.vue?vue&type=template&id=0b400a8a"
import script from "./OrderDetailsComponent.vue?vue&type=script&lang=js"
export * from "./OrderDetailsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/components/OrderDetailsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0b400a8a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0b400a8a', __exports__)) {
    api.reload('0b400a8a', __exports__)
  }
  
  module.hot.accept("./OrderDetailsComponent.vue?vue&type=template&id=0b400a8a", () => {
    api.rerender('0b400a8a', render)
  })

}


export default __exports__